export default __webpack_public_path__ + "static/media/gestao-assembleias-acionistas.b35a1ee5.svg";